import { z } from "zod";

export const highYieldCashStatusSchema = z.enum([
  "INACTIVE",
  "PENDING_CHANGE",
  "ACTIVE",
]);

export const highYieldCashAprTierSchema = z.object({
  tier_id: z.string(),
  tier_name: z.string(),
  account_rate_bps: z.number().optional(),
});

export const highYieldCashStatusResponseSchema = z.object({
  status: highYieldCashStatusSchema.nullable(),
  tier_assignment: highYieldCashAprTierSchema.nullable(),
});

// Accepts the backend typo `montly_accrued_interest` until
// https://github.com/alpacahq/gobroker/pull/8911 ships.
//
// Success-path remapping lives here; the failure path (looseArray retaining a
// raw row) is covered by remediateAccruedInterestTypo in hyc.ts, which runs
// before parse so retained rows still expose monthly_accrued_interest.
export const highYieldCashAccruedInterestSummarySchema = z
  .object({
    date: z.string(),
    // Omitted on real summary rows; `total_accrued_interest` is serialized as a
    // string. Keep the record instead of dropping it via looseArray (consumers
    // read via `Number(...)`, so coercion preserves the number type).
    account_id: z.string().optional(),
    balance: z.string(),
    monthly_accrued_interest: z.string().optional(),
    montly_accrued_interest: z.string().optional(),
    total_accrued_interest: z.coerce.number(),
  })
  .transform(
    ({ montly_accrued_interest, monthly_accrued_interest, ...rest }) => ({
      ...rest,
      monthly_accrued_interest:
        monthly_accrued_interest ?? montly_accrued_interest ?? "",
    }),
  );
